"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouter = require("react-router");

var UrlPathParams = _interopRequireWildcard(require("../constants/UrlPathParams"));

var GoodTileLink = function GoodTileLink(_ref) {
  var goodUrlToken = _ref.goodUrlToken,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["goodUrlToken"]);
  return _react.default.createElement(_reactRouter.Link, (0, _extends2.default)({}, rest, {
    style: {
      textDecoration: 'none'
    },
    to: "/" + UrlPathParams.DIRECTORY_PAGE_PATH + "/" + goodUrlToken
  }));
};

GoodTileLink.propTypes = {
  goodUrlToken: _propTypes.default.string.isRequired
};
var _default = GoodTileLink;
exports.default = _default;
module.exports = exports.default;